export default __webpack_public_path__ + "static/media/newtradetoearn.d6f28594.png";